export class PreBillingGeneratePdfRequest {
  siteId: string
  startDate: string
  endDate: string
  articles: Article[]
  displayCode: boolean
  displayQuantity: boolean
  displaySteps: boolean
  displayUrgency: boolean
  displayLot: boolean
  displayPriceType: boolean
}

export class Article {
  id: string
  quantity: number
  sender: string
  steps: string[]
  urgency: string
  priceType: string
  unitPrice: number
  unitWaitingPrice: number
}
